import { DefaultErrorPageFrame, Head } from "@dreambigger/design-system";
import { FinancialInstitutionBootstrap } from "@dreambigger/shared/src/types";
import Image from "next/image";
import { useRouter } from "next/router";

type FinancialInstitutionInvalidPageProps = {
  financialInstitutionBootstrap: FinancialInstitutionBootstrap;
};

const FinancialInstitutionInvalidPage = ({
  financialInstitutionBootstrap: { name, skins },
}: FinancialInstitutionInvalidPageProps) => {
  const router = useRouter();
  const skinCode = router.locale;

  const skin = skins?.find((skin) => skin.code === skinCode) || skins?.[0];

  const head = {
    ...skin?.head,
    title: name,
    description: `Invalid - ${name}`,
  };

  return (
    <>
      <Head {...head} />
      <>
        <Head {...head} />
        <DefaultErrorPageFrame>
          <div
            style={{
              width: "250px",
              height: "250px",
              position: "relative",
            }}
          >
            <Image
              src={skin?.brand.primaryLogo || ""}
              alt="logo"
              layout="fill"
              objectFit="scale-down"
            />
          </div>
          <Image
            src="https://res.cloudinary.com/cotribute/image/upload/v1718955541/400-invalid_xp3vzc.svg"
            alt="lock icon"
            width={150}
            height={150}
            objectFit="scale-down"
          />
          <h1 className="sm_f-12 textPrimary fwb">400</h1>
          <h1 className="sm_f-7 textPrimary fwb">Invalid Request</h1>
          <p className="sm_f-5 textPrimary fwb">
            Sorry we are unable to process your request. Please contact support.
          </p>
        </DefaultErrorPageFrame>
      </>
    </>
  );
};

export default FinancialInstitutionInvalidPage;
